module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Harry Harrison\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Harry Harrison (1925–2012) began writing science fiction in the 1950s and remains one of the top-selling authors in the genre. Harrison is best known for his Stainless Steel Rat, Deathworld, and West of End series, as well as "), _c('I', [_vm._v("Make Room! Make Room!")]), _vm._v(", which was turned into the movie "), _c('I', [_vm._v("Soylent Green ")]), _vm._v("starring Charlton Heston and Edward G. Robinson. His novels have appeared on the "), _c('I', [_vm._v("New York Times")]), _vm._v(" bestseller list, and in 2009 he was awarded the Damon Knight SF Grand Master Award by the Science Fiction Writers of America.")], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/18TBcuP/tc-custom/9781466822818.jpg?1731007752521",
      "alt": "This image is the cover for the book Starworld, To the Stars Trilogy"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Starworld, To the Stars Trilogy\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_c('b', [_c('i', [_vm._v("Starworld ")]), _vm._v("completes Harry Harrison's epic To the Stars trilogy with one of the most breathtaking space sequences yet seen in science fiction.")]), _c('br'), _c('br'), _vm._v("The twilight planet of Halvmork is free. The Earth space fleet has left to guard the Homeworld and to prepare for the ultimate, cataclysmic showdown. For a moment, the entire galaxy seems to hold its breath..."), _c('br'), _c('br'), _vm._v("For Jan Kulozik, exiled on Halvmork, this is the moment of decision. Will he find himself a leader of a new society...or an eternal slave to the absolute power of Earth?"), _c('br'), _c('br'), _c('br'), _vm._v("At the Publisher's request, this title is being sold without Digital Rights Management Software (DRM) applied.")]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b7db194","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0